
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.137 7.854s5.448 5.165 5.943 5.66c.495.495-.212 1.486-.212 1.486L7.995 9.34l-.141-1.274c-.142.07-.212.142-.425.142-.141 0-.212 0-.354-.071 0 0-5.165 5.377-5.66 5.943-.354.425-1.344-.283-1.344-.283l5.66-5.872 1.203-.142c-.07-.07-.142-.212-.142-.354s0-.212.071-.354c0 0-5.448-5.165-5.943-5.66C.425.92 1.132 0 1.132 0l5.873 5.66.141 1.203c.142-.07.283-.141.425-.141s.212 0 .283.07c0 0 5.165-5.377 5.66-5.943.495-.566 1.415.212 1.415.212L9.27 6.934l-1.203.141c.142.071.142.213.142.354s0 .283-.071.425"}})])
          )
        }
      }
    